const e=async(e,t,n,r,i)=>{let{data:a}=await e.get(`/webhooks/${t}/${n}/${r}/events`,{params:i});return a};export{e as getWebhookEvents};
//# sourceMappingURL=get-webhook-events.mjs.map